import { Howl } from 'howler'
import Config from 'scripts/util/Config'

const AUDIO = {
  // boost: require('assets/audio/boost.wav'),
  boost: require('assets/audio/boost.mp3'),
  throw: require('assets/audio/throw.mp3'),
  splat: require('assets/audio/splat.mp3'),
  // collectTime: require('assets/audio/time.wav'),
  collectTime: require('assets/audio/time.mp3'),
  gameMusic: require('assets/audio/gameMusic.mp3'),
  // hit: require('assets/audio/hit.wav'),
  hit: require('assets/audio/hit.mp3'),
  icePatch: require('assets/audio/icePatch.mp3'),
  jump: require('assets/audio/jump.mp3'),
  jumpLand: require('assets/audio/jumpLand.mp3'),
  // present: require('assets/audio/present.wav'),
  present: require('assets/audio/present.mp3'),
  snowball: require('assets/audio/snowball.mp3'),
  starCollect: require('assets/audio/starCollect.mp3'),
  starFadeOut: require('assets/audio/starFadeOut.mp3'),
  uiSelect: require('assets/audio/uiSelect.mp3'),
  uiAccept: require('assets/audio/uiAccept.mp3'),
  // uiMusic: require('assets/audio/uiMusic.wav'),
  // uiTransition: require('assets/audio/uiTransition.wav'),
  uiMusic: require('assets/audio/uiMusic.mp3'),
  uiTransition: require('assets/audio/uiTransition.mp3'),
}

class AudioManager {
  constructor () {
    this.tracks = {}
  }

  playSound (key, vol = 0.5) {
    if (Config.isMuted()) {
      return
    }
    if (AUDIO[key]) {
      let sound = new Howl({
        src: [AUDIO[key].default],
        volume: vol,
      })
      sound.play()
    } else {
      console.log(`Audio Sound for ${key} is invalid!`)
    }
  }

  playTrack (key, volume = 0.05) {
    if (Config?.isMuted()) {
      return
    }
    if (AUDIO[key]) {
      this.stopTracks()
      this.tracks[key] = new Howl({
        src: [AUDIO[key].default],
        loop: true,
        autoplay: true,
        volume,
      })
    } else {
      console.log(`Audio Track for ${key} is invalid!`)
    }
  }

  stopTracks () {
    const trackKeys = Object.keys(this.tracks)
    trackKeys.forEach(key => {
      this.tracks[key].stop()
      this.tracks[key].unload()
      this.tracks[key] = null
      delete this.tracks[key]
    })
  }
  
  pauseTracks () {
    const trackKeys = Object.keys(this.tracks)
    trackKeys.forEach(key => {
      this.tracks[key].pause()
    })
  }

  resumeTracks () {
    const trackKeys = Object.keys(this.tracks)
    trackKeys.forEach(key => {
      this.tracks[key].play()
    })
  }
}

export default new AudioManager()